<section class="content early-exit-page">
  <div class="content-block">
    <app-breadcrumb [title]="'earlyExitsCatalog.breadcrumb.title' | translate"
                    [items]="['earlyExitsCatalog.breadcrumb.section' | translate]"
                    [active_item]="'earlyExitsCatalog.breadcrumb.title' | translate" />

    <div class="early-exit-filters">
      @if (companies.length > 1) {
      <app-company-select class="early-exit-filter-field" [records]="companies"
                          [value]="filters.companiesRecordId" [includeAll]="true"
                          [label]="'orgUnitsCatalog.fields.company' | translate"
                          [placeholder]="'earlyExitsCatalog.filters.allCompanies' | translate"
                          [allLabel]="'earlyExitsCatalog.filters.allCompanies' | translate"
                          (valueChange)="filters.companiesRecordId = $event; onCompanyChanged()" />
      }

      <app-org-unit-tree-select class="early-exit-filter-field"
                                [units]="orgUnits"
                                [value]="filters.orgUnitId"
                                [placeholder]="'earlyExitsCatalog.filters.allOrgUnits' | translate"
                                [searchPlaceholder]="'employeesCatalog.orgUnitPicker.searchPlaceholder' | translate"
                                (valueChange)="filters.orgUnitId = $event; onOrgUnitChanged()" />

      <mat-form-field class="early-exit-filter-field" appearance="outline" subscriptSizing="dynamic">
        <mat-icon matPrefix>badge</mat-icon>
        <input matInput
               [placeholder]="'earlyExitsCatalog.filters.employeePlaceholder' | translate"
               [ngModel]="employeeSearchText"
               (ngModelChange)="onEmployeeInput($event)"
               [matAutocomplete]="employeeAutocomplete" />
        <mat-autocomplete #employeeAutocomplete="matAutocomplete"
                          [displayWith]="displayEmployee"
                          (optionSelected)="onEmployeeSelected($event)">
          @for (employee of employees; track employee.employeeId) {
            <mat-option [value]="employee">{{ displayEmployee(employee) }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <div class="early-exit-week-filter">
        <button mat-icon-button type="button" (click)="changeWeek(-1)"
                [attr.aria-label]="'earlyExitsCatalog.actions.previousWeek' | translate">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <app-date-time-picker-field class="early-exit-date-filter"
                                    [label]="'earlyExitsCatalog.filters.week' | translate"
                                    [value]="filters.weekDate"
                                    mode="date"
                                    (valueChange)="onWeekDateChanged($event)" />
        <button mat-icon-button type="button" (click)="changeWeek(1)"
                [attr.aria-label]="'earlyExitsCatalog.actions.nextWeek' | translate">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="early-exit-filters__actions">
        <button mat-icon-button type="button" class="early-exit-refresh-button" (click)="refreshTable()"
                [disabled]="isLoading" [attr.aria-label]="'common.refresh' | translate">
          <mat-icon [class.is-spinning]="isLoading">refresh</mat-icon>
        </button>
        <button mat-icon-button type="button" class="early-exit-clear-button" (click)="clearFilters()"
                [attr.aria-label]="'earlyExitsCatalog.actions.clear' | translate">
          <mat-icon>filter_alt_off</mat-icon>
        </button>
      </div>
    </div>

    <div class="early-exit-list-card">
      @if (isLoading) {
        <app-loading-state [overlay]="false" [message]="'earlyExitsCatalog.loading' | translate" />
      } @else if (!rows.length) {
        <div class="early-exit-empty">
          <span><mat-icon>schedule</mat-icon></span>
          <h3>{{ 'earlyExitsCatalog.empty.title' | translate }}</h3>
          <p>{{ 'earlyExitsCatalog.empty.description' | translate }}</p>
        </div>
      } @else {
        <div class="early-exit-list-scroll">
          <table class="early-exit-list">
            <thead>
              <tr>
                <th class="early-exit-employee-column">{{ 'earlyExitsCatalog.table.employee' | translate }}</th>
                <th>{{ 'earlyExitsCatalog.table.detectedEarlyExits' | translate }}</th>
                <th class="early-exit-total-column">{{ 'earlyExitsCatalog.table.weekTotal' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row.employeeId) {
                <tr>
                  <td class="early-exit-employee-column">
                    <div class="early-exit-employee">
                      <span class="early-exit-avatar">{{ row.employeeName.charAt(0) }}</span>
                      <div>
                        <strong>{{ row.employeeName }}</strong>
                        <span>{{ row.employeeNumber }}</span>
                        <small>{{ row.orgUnitName }}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="early-exit-events">
                      @for (item of earlyExitsForRow(row); track item.result.attendanceResultId) {
                        <article class="early-exit-event" [class.early-exit-event--justified]="hasJustification(item.result)">
                          <span class="early-exit-event__date">
                            <strong>{{ item.day.weekday }}</strong>
                            {{ item.day.dayLabel }}
                          </span>
                          <span class="early-exit-event__status">
                            <mat-icon>schedule</mat-icon>
                            <span>
                              <strong>
                                {{ (hasJustification(item.result) ? 'earlyExitsCatalog.status.justified' : 'earlyExitsCatalog.status.earlyExit') | translate }}
                                · {{ earlyExitMinutesLabel(item.result) }} {{ 'earlyExitsCatalog.table.minutesShort' | translate }}
                              </strong>
                              <small>{{ 'earlyExitsCatalog.table.exit' | translate }} {{ exitTime(item.result) }}</small>
                            </span>
                          </span>
                          @if (!hasJustification(item.result) && canCreateJustification) {
                            <button mat-icon-button type="button" (click)="createJustification(item.result)"
                                    [attr.aria-label]="'earlyExitsCatalog.actions.justify' | translate">
                              <mat-icon>note_add</mat-icon>
                            </button>
                          } @else {
                            <button mat-icon-button type="button" (click)="viewResult(item.result)"
                                    [attr.aria-label]="'earlyExitsCatalog.actions.view' | translate">
                              <mat-icon>visibility</mat-icon>
                            </button>
                          }
                        </article>
                      }
                    </div>
                  </td>
                  <td class="early-exit-total-column">
                    <span class="early-exit-total">{{ totalEarlyExitMinutes(row) }}</span>
                    <small>{{ 'earlyExitsCatalog.table.minutes' | translate }}</small>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <mat-paginator [length]="totalItems"
                       [pageIndex]="currentPage - 1"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="[25, 50, 100]"
                       showFirstLastButtons
                       (page)="onPageChange($event)" />
      }
    </div>
  </div>
</section>
